import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION10: PdfComponent = {
  type: 'section',
  id: 'iars10',
  title: '10. Remuneration and Set-Off',
  content: [
    {
      type: 'bulletList',
      id: 'iars11bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'This Agreement may be terminated:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: {
                  type: 'altText',
                  id: 'iar101',
                  content: [
                    'By either party with ',
                    "30 days' written notice",
                    ';',
                  ],
                  boldFirst: false,
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: 'iar102',
                  content: [
                    'By the Principal ',
                    'immediately',
                    ' for cause, including regulatory breaches, insolvency, or unsuitability;',
                  ],
                  boldFirst: false,
                },
              },
              {
                copy: 'Automatically, if the Principal’s FCA permissions are withdrawn or if the Introducer ceases to appear on the FCA Register.',
              },
            ],
          },
        },
        {
          copy: 'Upon termination:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'All confidential material must be returned;',
              },
              {
                copy: 'No further introductions may be made;',
              },
              {
                copy: 'Any surviving obligations, including indemnities and confidentiality, shall continue.',
              },
            ],
          },
        },
      ],
      prefix: '10',
    },
  ],
};
